'use client';

import React from 'react';

import {
    Box,
    Button,
    Popover,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
} from '@chakra-ui/react';
import { useRouter } from 'next/navigation';
import { MdExpandMore } from 'react-icons/md';

import { PrimaryButton } from '@components/custom-buttons';
import { paths } from '@routes/path';

const NavButtons = () => {
    const router = useRouter();
    return (
        <>
            <Popover placement="bottom-end">
                <PopoverTrigger>
                    <Button
                        variant="outline"
                        color="primary.light"
                        borderColor="primary.light"
                        fontWeight={400}
                        fontSize="16px"
                        lineHeight="24px"
                        rightIcon={<MdExpandMore size={16} />}
                    >
                        Sign In
                    </Button>
                </PopoverTrigger>
                <PopoverContent width="fit-content">
                    <PopoverBody>
                        <Box
                            as="button"
                            display="block"
                            w="full"
                            textAlign="left"
                            py={2}
                            px={4}
                            fontSize="18px"
                            lineHeight="28px"
                            _hover={{ bg: 'gray.100' }}
                            onClick={() => router.push(paths.mentee.auth.login)}
                        >
                            Sign In as Mentee
                        </Box>
                        <Box
                            as="button"
                            display="block"
                            w="full"
                            textAlign="left"
                            py={2}
                            px={4}
                            fontSize="18px"
                            lineHeight="28px"
                            _hover={{ bg: 'gray.100' }}
                            onClick={() => router.push(paths.mentor.auth.login)}
                        >
                            Sign In as Mentor
                        </Box>
                    </PopoverBody>
                </PopoverContent>
            </Popover>
            <PrimaryButton
                type="button"
                buttonLabel="Signup as Mentee"
                onClick={() => {
                    router.push(paths.mentee.auth.signup);
                }}
            />
        </>
    );
};

export default NavButtons;
